export default __webpack_public_path__ + "static/media/demand.67952797.svg";